import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Snackbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import logoImage from "../../../assets/images/logo.png";
import callApi from "../../../services/callApi";
import Loader from "../../../components/Loader/Loader";

export default function DatosTransferencia() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [titulo, setTitulo] = useState("Felipe Larraín");
  const [profesion, setProfesion] = useState("Fisioterapeuta");
  const [servicio_nombre, setServicioNombre] = useState("Nombre del servicio");
  const [servicio_precios, setServicioPrecios] = useState("$10.000");
  const [servicio_modalidad, setServicioModalidad] = useState("(modalidad)");
  const [fecha_formateada, setFechaFormateada] = useState("");
  const [hourss, setHourss] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [textoVisible, setTextoVisible] = useState("");
  const textoInstrucciones =
    "Abre la aplicación de tu Banco y haz la transferencia. Luego vuelve y haz click en el botón ya transferí";

    useEffect(() => {
      setTextoVisible(textoInstrucciones);
    }, []);

  const datosBancarios = {
    nombre: "Clinifica Chile SPA",
    rut: "77.729.376-1",
    banco: "BCI/MACH (Banco Crédito e Inversiones)",
    tipoCuenta: "Cuenta corriente",
    numeroCuenta: "29056012",
    email: "pagos@clinifica.com",
    monto: "$10.000",
  };

  useEffect(() => {
    if (location.state && location.state.transferenciaInfo) {
      const transf = location.state.transferenciaInfo;

      if (transf.profesional_nombres && transf.profesional_apellidos) {
        setTitulo(
          `${transf.profesional_nombres} ${transf.profesional_apellidos}`
        );
      }
      if (transf.profesional_profesion)
        setProfesion(transf.profesional_profesion);
      if (transf.servicio_nombre) setServicioNombre(transf.servicio_nombre);
      if (transf.servicio_precio) {
        const precio = new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(transf.servicio_precio);
        setServicioPrecios(precio);
        datosBancarios.monto = precio;
      }
      if (transf.servicio_modalidad)
        setServicioModalidad(transf.servicio_modalidad);
      if (transf.fecha_agenda)
        setFechaFormateada(transf.fecha_agenda_corta || transf.fecha_agenda);
      if (transf.hora_agenda) setHourss(transf.hora_agenda);
    }
  }, [location.state]);

  const handleTransferir = async () => {
    setIsLoading(true);

    try {
      if (location.state && location.state.transferencia_id) {
        const response = await callApi(
          `/transferencia/transferenciaMovimientos`,
          "post",
          { transferencia_id: location.state.transferencia_id }
        );

        if (response && response.estado === "exito") {
          navigate("/pro/transferencia/validador", {
            state: {
              ...location.state,
              transaccion_id: response.transaccion_id,
            },
          });
        } else {
          setSnackbarMessage("No se pudo procesar la transferencia");
          setSnackbarOpen(true);
        }
      } else {
        console.error("No hay transferencia_id disponible");
        setSnackbarMessage("Error: datos de transferencia no disponibles");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error(
        "Error al registrar el movimiento de transferencia:",
        error
      );
      setSnackbarMessage("Error al procesar la transferencia");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setSnackbarMessage("Copiado al portapapeles");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.error("Error al copiar: ", err);
        setSnackbarMessage("Error al copiar");
        setSnackbarOpen(true);
      });
  };

  const copyAllToClipboard = () => {
    const formatoCopiado = `Nombre: ${datosBancarios.nombre}
RUT: ${datosBancarios.rut}
Banco: ${datosBancarios.banco}
Tipo de cuenta: ${datosBancarios.tipoCuenta}
Número de cuenta: ${datosBancarios.numeroCuenta}
Email: ${datosBancarios.email}`;

    navigator.clipboard
      .writeText(formatoCopiado)
      .then(() => {
        setSnackbarMessage("Todos los datos copiados al portapapeles");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.error("Error al copiar: ", err);
        setSnackbarMessage("Error al copiar");
        setSnackbarOpen(true);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };


  
  const transformModalidad = (modalidad) => {
    switch (modalidad) {
      case "consultorio":
        return "Consulta presencial";
      case "domicilio":
        return "Consulta a domicilio";
      case "online":
        return "Consulta online";
      default:
        return modalidad;
    }
  };

  const formatearFechaSinAnio = (fecha) => {
    if (!fecha) return "";
    return fecha.slice(0, -5);
  };

  const dataFieldStyle = {
    display: "flex",
    flexDirection: "column",
    mb: 2,
  };

  const dataLabelStyle = {
    fontFamily: "Quicksand-Regular",
    fontSize: isMobile ? "14px" : "16px",
    color: "#191C1F",
  };

  const dataValueStyle = {
    borderRadius: 2,
    border: "1px solid #909090",           // ← Borde gris igual que los otros campos
    backgroundColor: "#f8f9fa",            // ← Fondo ligeramente gris para mostrar que no es editable
    p: 0.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // ← NO agregar &:focus-within porque estos campos no son editables
  };
  
  const dataValueTextStyle = {
    fontFamily: "Quicksand-Regular",
    fontSize: { md: "16px", xs: "14px" },
    color: "#4F4F4F",
    background: "transparent",
    border: "none",
    outline: "none",
    width: "100%",
    padding: 0,
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <img
        src={logoImage}
        alt="Clinifica Logo"
        style={{
          width: isMobile ? "150px" : "200px",
          height: "auto",
          paddingTop: "15px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          padding: 15,
        }}
      />
      
      <Box
        translate="no"
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "#fbfafe",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 2,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography sx={{ 
          fontFamily: "Quicksand-Regular",
          color: "#626262",
          fontSize: { xs: "14px", md: "16px" },
          mb: 0
        }}>
          Estas agendando con:
        </Typography>
        <Typography
          sx={{
            mt: -0.5,
            fontFamily: "Quicksand-Bold",
            fontSize: { xs: "18px", md: "20px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {titulo}
        </Typography>
        <Typography
          sx={{ 
            fontFamily: "Quicksand-Regular", 
            mt: -0.5,
            fontSize: { xs: "14px", md: "16px" },
            color: "default",
            mb: 0
          }}
        >
          {profesion}
        </Typography>
        <Typography sx={{ 
          fontFamily: "Quicksand-Regular",
          color: "#626262",
          mt: 2,
          fontSize: { xs: "14px", md: "16px" },
          mb: 0
        }}>
          El servicio de:
        </Typography>
        <Typography
          sx={{
            mt: -0.5,
            fontFamily: "Quicksand-Bold",
            fontSize: { xs: "18px", md: "20px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {servicio_nombre}
        </Typography>
        <Typography
          sx={{ 
            fontFamily: "Quicksand-Regular", 
            mt: -0.5,
            fontSize: { md: "16px", xs: "14px" },
            color: "#191C1F",
            mb: 0
          }}
        >
          {servicio_precios}
        </Typography>
        <Box
          sx={{
            display: "inline-block",
            backgroundColor: "#f0f4ff",
            color: "#3B82F6",
            fontFamily: "Quicksand-Medium",
            fontSize: { md: "15px", xs: "13px" },
            borderRadius: 2,
            paddingLeft: 0.75,
            paddingRight: 0.75,
            paddingTop: 0.25,
            paddingBottom: 0.25,
            marginLeft: -0.75,
            mt: -0.75,
            textAlign: "left",
          }}
        >
          {transformModalidad(servicio_modalidad)}
        </Box>
        {fecha_formateada && (
          <Typography
            sx={{
              mt: 0,
              color: "#007FFF",
              fontFamily: "Quicksand-Bold",
              fontSize: { md: "16px", xs: "14px" },
            }}
          >
            {formatearFechaSinAnio(fecha_formateada)} {hourss ? "-" : ""}{" "}
            {hourss}
          </Typography>
        )}
      </Box>

      <Typography
        sx={{
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "24px", xs: "20px" },
          textAlign: "center",
          color: "#191C1F",
          mt: 3,
          mb: 1
        }}
      >
        Datos para la transferencia
      </Typography>

      <Box
        translate="no"
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "white",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 8,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "66.67%" },
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              mt: 3,
              mb: 2,
              fontFamily: "Quicksand-Regular",
              fontSize: { md: "16px", xs: "14px" },
              color: "#191C1F",
              textAlign: "center",
            }}
          >
            {textoVisible}
          </Typography>

          <Box
            sx={{
              backgroundColor: "#FFF9E6",
              p: 1,
              borderRadius: 1,
              mt: 1,
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Quicksand-Bold",
                fontSize: { md: "16px", xs: "14px" },
                textAlign: "center",
                background: "linear-gradient(90deg, #7D6E25 30%,rgb(236, 235, 223) 40%, #7D6E25 50%)",
                backgroundSize: "200% 100%",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                animation: "shimmer 5.0s ease-in-out infinite",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "100% 0" },
                  "100%": { backgroundPosition: "-100% 0" }
                }
              }}
            >
              <span style={{ fontFamily: "Quicksand-Bold" }}>IMPORTANTE:</span>{" "}
              El pago SOLO será validado si el monto de la transferencia es
              exactamente{" "}
              <span style={{ fontFamily: "Quicksand-Bold" }}>
                {servicio_precios} y
              </span>{" "}
              si la cuenta desde la que se envía el dinero pertenece al RUT{" "}
              <span style={{ fontFamily: "Quicksand-Bold" }}>
                {location.state?.rutPagador}
              </span>
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "#2669A8",
              p: 2,
              borderRadius: 2,
              mt: 3,
              mb: 3,
              display: "none",
            }}
            id="copiado-ejemplo"
          >
            <Typography
              sx={{
                fontFamily: "Quicksand-Bold",
                fontSize: "14px",
                color: "white",
                mb: 1,
              }}
            >
              Copiar todo, copia esto:
            </Typography>
            <Box sx={{ backgroundColor: "#fff", p: 2, borderRadius: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Quicksand-Regular",
                  fontSize: "14px",
                  "& .highlight": {
                    backgroundColor: "#ff00ff",
                    color: "white",
                    fontWeight: "bold",
                    px: 0.5,
                    display: "block",
                    mb: 0.5,
                  },
                }}
              >
                <span className="highlight">Nombre: Clinifica Chile SPA</span>
                <span className="highlight">RUT: 77.729.375-1</span>
                <span className="highlight">
                  Banco: BCI/MACH (Banco Crédito e Inversiones)
                </span>
                <span className="highlight">
                  Tipo de cuenta: Cuenta corriente
                </span>
                <span className="highlight">Número de cuenta: 29050612</span>
                <span className="highlight">Email: pagos@clinifica.com</span>
              </Typography>
            </Box>
          </Box>

          <Box sx={{}}>
            <Box sx={{dataFieldStyle, mb: 1}}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={dataLabelStyle}>Nombre</Typography>
                <span
                  onClick={copyAllToClipboard}
                  style={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: isMobile ? "13px" : "15px",
                    color: "#3B82F6",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "8px",  // ← Esto mueve 8px a la izquierda
                  }}
                >
                  Copiar todo
                </span>
              </Box>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.nombre}</span>
                <span
                  onClick={() => copyToClipboard(datosBancarios.nombre)}
                  style={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: isMobile ? "13px" : "15px",
                    color: "#3B82F6",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "8px",  // ← Esto mueve 8px a la izquierda
                  }}
                >
                  copiar
                </span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>RUT</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.rut}</span>
                <span
                  onClick={() => copyToClipboard(datosBancarios.rut)}
                  style={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: isMobile ? "13px" : "15px",
                    color: "#3B82F6",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "8px",  // ← Esto mueve 8px a la izquierda
                  }}
                >
                  copiar
                </span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>Banco</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.banco}</span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>Tipo de cuenta</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.tipoCuenta}</span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>Número de Cuenta</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.numeroCuenta}</span>
                <span
                  onClick={() => copyToClipboard(datosBancarios.numeroCuenta)}
                  style={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: isMobile ? "13px" : "15px",
                    color: "#3B82F6",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "8px",  // ← Esto mueve 8px a la izquierda
                  }}
                >
                  copiar
                </span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>Email</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{datosBancarios.email}</span>
                <span
                  onClick={() => copyToClipboard(datosBancarios.email)}
                  style={{
                    fontFamily: "Quicksand-Bold",
                    fontSize: isMobile ? "13px" : "15px",
                    color: "#3B82F6",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "8px",  // ← Esto mueve 8px a la izquierda
                  }}
                >
                  copiar
                </span>
              </Box>
            </Box>

            <Box sx={{dataFieldStyle, mb: 1}}>
              <Typography sx={dataLabelStyle}>Monto a transferir</Typography>
              <Box sx={dataValueStyle}>
                <span style={dataValueTextStyle}>{servicio_precios}</span>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Button
              translate="no"
              variant="contained"
              disableRipple
              disableElevation
              disableFocusRipple
              onClick={handleTransferir}
              sx={{
                fontSize: { xs: "14px", md: "16px", lg: "16px" },
                fontFamily: "Quicksand-Bold",
                backgroundColor: "#3B82F6",
                "&:hover": { 
                  backgroundColor: "#3B82F6",
                  boxShadow: "none !important",
                },
                "&:active": {
                  backgroundColor: "#3B82F6",
                  boxShadow: "none !important",
                },
                "&:focus": {
                  backgroundColor: "#3B82F6",
                  boxShadow: "none !important",
                },
                borderRadius: 2,
                width: "100%",
                paddingTop: 2,
                paddingBottom: 2,
                mb: isMobile ? 2 : 4,
                textTransform: "none",
                boxShadow: "none !important",
                transition: "none !important",
                "& .MuiTouchRipple-root": {
                  display: "none",
                },
              }}
            >
              YA TRANSFERÍ {servicio_precios}
            </Button>
          </Box>
        </Box>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
}

